
/**
 * 평점별 분포
 */
export type ReviewStatsResponseRatingDistribution = {
  five: number;
  four: number;
  one: number;
  three: number;
  two: number;
};
